import { Component } from '@angular/core';
import { InternalReleaseNotesService } from './internal-release-notes.service';
import  moment from 'moment';

type WorkItemMap = Record<string, any[]>;

@Component({
    templateUrl: './internal-release-notes.template.html',
    standalone: false
})
export class InternalReleaseNotesComponent {

    public history: any = [];

    constructor(private internalReleaseNotesService: InternalReleaseNotesService) {}

    public async ngAfterViewInit() {
        const history = await this.internalReleaseNotesService.get();

        this.history = history.versions
            .map((version) => {
                const workItems = version.changesets.reduce((acc, curr) => {
                    curr.workItems.map((workItem) => {
                        let existingWorkItem = acc.find((current) => current.id === workItem.id);
                        if(!existingWorkItem) {
                            existingWorkItem = {
                                id: workItem.id,
                                label: workItem.label,
                                url: workItem.url,
                                changesets: []
                            };
                            acc.push(existingWorkItem);
                        }

                        existingWorkItem.changesets.push({
                            uuid: curr.uuid,
                            comment: curr.comment,
                            url: curr.url,
                            creationDate: new Date(curr.creationDate)
                        });
                    });
                    return acc;
                }, []);

                return {
                    // latestChangesetDate: new Date(
                    //     version.changesets.sort((a, b) => a.creationDate > b.creationDate ? -1 : 1)[0].creationDate
                    // ),
                    name: version.name,
                    oldBaseline: version.oldBaseline,
                    newBaseline: version.newBaseline,
                    oldBaselineDate: moment(version.oldBaselineDate).format('DD.MM.YYYY'),
                    newBaselineDate: moment(version.newBaselineDate).format('DD.MM.YYYY'),
                    workItems
                };
            })
            .sort((a, b) => a.latestChangesetDate > b.latestChangesetDate ? -1 : 1);
    }
}
